import { render, staticRenderFns } from "./CheckoutDesc.vue?vue&type=template&id=72fa5c18&scoped=true&"
import script from "./CheckoutDesc.vue?vue&type=script&lang=js&"
export * from "./CheckoutDesc.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutDesc.vue?vue&type=style&index=0&id=72fa5c18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fa5c18",
  null
  
)

export default component.exports